import { action, computed, observable } from 'mobx'
import Api from '@api/kong_kong/ControlBoard'
import { isMasterEnv, isReleaseEnv } from '@hlj/hlj-utils'
import { message, Modal } from 'hljd'
import ChatStore from './Chat/store'
import LiveLotteryStore from './VideoContent/liveLottery/store'
import LiveLinkMicrophoneStore from './VideoContent/liveLinkMicrophone/store'
import sha1 from 'sha1'
import {
  CASE_TYPE_ID,
  HALL_TYPE_ID,
  livingNetStatus,
  MERCHANT_NO_SPREAD,
  MSG_HALL_CONFIG,
  MSG_INTENT_CONFIG,
  MSG_PACKAGE_CONFIG,
  OPERATE_NO_SPREAD,
  PACKAGE_TYPE_ID,
  VIDEO_LIVING,
  VIDEO_REVIEW
} from './constant'
import { isHotelMerchant } from '@util'

const confirm = Modal.confirm

export default class {
  constructor(id) {
    this.id = id
  }
  id = '' // 直播id
  live_role = '3' // 1主持人 2嘉宾用户 3普通用户
  @observable chatStore = new ChatStore()
  @observable liveLotteryStore = new LiveLotteryStore()
  @observable liveLinkMicrophoneStore = new LiveLinkMicrophoneStore(this.id)
  @observable detail = {} //直播详情
  @observable consoleStatistical = {} // 直播统计数据
  @observable
  videoSeek = {
    // 视频裁剪数据
    startHour: '',
    startMin: '',
    startSec: '',
    endHour: '',
    endMin: '',
    endSec: ''
  }
  @observable shareImage = '' // 直播配图

  @observable packageRecommendId = '' // 套餐关联id
  @observable packageList = [] // 直播套餐 type= 4
  @observable entityIntroduced = '' // 被介绍中套餐id

  @observable caseRecommendId = '' // 案例关联id
  @observable caseList = [] // 直播案例 type=7

  @observable allPackageList = [] // 所有套餐列表
  @observable allCaseList = [] // 所有案例列表

  @observable qrModalVisable = false // 二维码弹框
  @observable caseModalStatus = false // 案例弹窗
  @observable packageModalStatus = false // 套餐弹窗
  @observable spreadModal = false // 推广时长弹窗
  @observable liveStatus = '' // 直播状态
  @observable videoNetStatus = '' // 直播网络状态
  videoRef = '' // 直播节点

  initData() {
    this.getConsoleStatistical()
    this.getDetail()
    this.getResourcesList(1) // 所有案例
    isHotelMerchant() ? this.getResourcesList(8) : this.getResourcesList(0) // 8:宴会厅；0：套餐
    this.initSocket()
    this.chatStore.initData(this.id)
    this.liveLinkMicrophoneStore.initData()
  }

  // 初始化socket，用处：聊天室、直播连麦
  initSocket = () => {
    const ws = new WebSocket(
      `${this.getWebSocketUrl().webSocketUrl}?channel_id=${this.id}&live_role=${
        this.live_role
      }`
    )
    this.ws = ws
    ws.onopen = () => {
      console.log('web socket 连接已打开')
    }

    ws.onmessage = evt => {
      const resp = JSON.parse(evt.data)
      const { msg_type } = resp
      console.log('web socket ws-已接收消息', resp)

      // 心跳
      if (msg_type == 9) {
        const msg = {
          msg_type: 10
        }
        ws.send(JSON.stringify(msg))
      }
      // 直播连麦
      this.liveLinkMicrophoneStore.handleWSData(resp)
      // 聊天室
      this.chatStore.handleWSData(resp)
      // 网络状态
      this.handleWSData(resp)
    }

    ws.onerror = evt => {
      console.log('web socket 连接错误', evt)
    }

    ws.onclose = evt => {
      console.log('web socket 连接已断开', evt)
    }
  }

  // 获取网络状态
  handleWSData = _data => {
    const { msg_type, data = {} } = _data
    if (msg_type == 2) {
      const { live_list = [] } = data.message || {}
      const item = live_list && live_list[0]
      console.log('处理网络状态：', item)
      if (item) {
        const { msg_kind } = item
        const content = JSON.parse(item.content || '{}')
        if (msg_kind == livingNetStatus) {
          this.videoNetStatus = content.state || '0'
        }
      }
    }
  }

  getWebSocketUrl = () => {
    let webSocketUrl = ''
    let url = ''

    if (isMasterEnv()) {
      url = 'https://message.hunliji.com:5051/chat'
      webSocketUrl = 'wss://message.hunliji.com:5051/chat'
    } else if (isReleaseEnv()) {
      url = '//message.hunliji.com:5055/chat'

      webSocketUrl = `${
        window.location.protocol.indexOf('https') > -1 ? 'wss' : 'ws'
      }://message.hunliji.com:5055/chat`
    } else {
      url = 'http://test.hunliji.com:5050'
      webSocketUrl = 'ws://test.hunliji.com:5050/chat'
    }
    return {
      webSocketUrl,
      domain: url
    }
  }

  // 直播视频是否可以预览 商家未推广&直播中
  @computed
  get isPreview() {
    return (
      this.liveStatus == VIDEO_LIVING &&
      (this.detail.fromType == MERCHANT_NO_SPREAD ||
        this.detail.fromType == OPERATE_NO_SPREAD)
    )
  }

  // 是否展示
  @computed
  get isShowVideo() {
    return this.liveStatus == VIDEO_LIVING || this.liveStatus == VIDEO_REVIEW
  }

  // 获取直播详情
  @action
  getDetail = async () => {
    const type = isHotelMerchant() ? HALL_TYPE_ID : PACKAGE_TYPE_ID
    const { data } = await Api.getVideoDetail({ id: this.id })
    const recommendList = data.recommendList || []
    const packageObj = recommendList.find(item => item.type == type)
    const caseObj = recommendList.find(item => item.type == CASE_TYPE_ID)

    this.detail = data
    this.liveStatus = data.status
    if (packageObj && packageObj.entity) {
      this.packageList = packageObj.entity
      this.packageRecommendId = packageObj.id
      this.entityIntroduced = packageObj.entityIntroduced
    }

    if (caseObj && caseObj.entity) {
      this.caseList = caseObj.entity
      this.caseRecommendId = caseObj.id
    }

    this.shareImage = data.shareImagePath

    if (data.hostList && data.hostList[0]) {
      this.chatStore.initHost(data.hostList[0])
    }

    this.liveLotteryStore.initData(this.id, this.liveStatus)

    // 初始化视频节点
    setTimeout(() => {
      this.initVideo()
    })
  }

  // 获取统计数据
  @action
  getConsoleStatistical = async () => {
    const { data, RetCode } = await Api.getConsoleStatistical({ id: this.id })
    if (RetCode === 0) {
      this.consoleStatistical = data
    }
  }

  @action
  changeVideoSeek = type => e => {
    this.videoSeek[type] = e
  }

  // 裁剪视频
  @action
  submitVideoSeek = () => {
    // TODO 验证填写裁剪数据是否正确
    confirm({
      title: '确认裁剪',
      content: '截取成功后仅在用户端更新，商家中心保留完整视频',
      cancelText: '取消',
      okText: '确定裁剪',
      onOk: async () => {
        const params = {
          ...this.videoSeek,
          id: this.id
        }
        const { RetCode } = await Api.postVideoSeek(params)
        if (RetCode === 0) {
          message.success('视频截取成功')
        }
      }
    })
  }

  // 结束直播
  @action
  endVideo = () => {
    confirm({
      title: '结束直播',
      content: '你确定结束直播？',
      cancelText: '取消',
      okText: '确定结束',
      onOk: async () => {
        const { RetCode } = await Api.endLiveChannel({
          id: this.id
        })

        if (RetCode === 0) {
          message.success('直播已结束！')
        }
      }
    })
  }

  // 删除案例 | 套餐
  @action
  deleteRecommend = (typeId, itemId, index) => async () => {
    const params = {
      id: this.id,
      entityId: itemId
    }
    if (typeId == CASE_TYPE_ID) {
      params['recommendId'] = this.caseRecommendId
      if (this.caseList.length <= 1) {
        message.warning('至少需要设置1个案例')
        return
      }
    } else if (typeId == PACKAGE_TYPE_ID || typeId == HALL_TYPE_ID) {
      params['recommendId'] = this.packageRecommendId
    }

    const { RetCode } = await Api.deleteRecommend(params)
    if (RetCode === 0) {
      if (typeId == CASE_TYPE_ID) {
        this.caseList.splice(index, 1)
      } else if (typeId == PACKAGE_TYPE_ID || typeId == HALL_TYPE_ID) {
        this.packageList.splice(index, 1)
      }
    }
  }

  // 设置套餐为介绍中
  @action
  setRecommendIntroduce = itemId => async () => {
    const params = {
      id: this.id,
      entityId: itemId,
      type: isHotelMerchant() ? '8' : '4'
    }

    const { RetCode, data } = await Api.setLiveChannelRecommendIntroduce(params)
    if (RetCode === 0) {
      this.entityIntroduced = itemId
      const hostId = this.detail.hostList[0].hostId
      await Api.chatAddMsg({
        channel_id: this.id,
        content: JSON.stringify(data.content),
        host_id: hostId,
        sign: sha1(`key=hunliji2016&host_id=${hostId}`),
        msg_kind: !isHotelMerchant() ? MSG_PACKAGE_CONFIG : MSG_HALL_CONFIG
      })
    }
  }

  // 修改直播配图
  @action
  editShareImage = async ({ clipUrl }) => {
    const { RetCode } = await Api.editLiveChannelShareImage({
      id: this.id,
      url: clipUrl
    })

    if (RetCode === 0) {
      this.shareImage = clipUrl
    }
  }

  // 删除直播配图
  @action
  deleteShareImage = () => {
    this.editShareImage({ clipUrl: '' })
  }

  // 修改预览二维码状态
  @action
  changeQrModalVisable = () => {
    this.qrModalVisable = !this.qrModalVisable
  }

  /**
   * 套餐和案例列表
   * type 0:套餐  1：案例  8: 宴会厅
   */
  @action
  getResourcesList = async type => {
    this.loading = true

    const params = {
      page: 1,
      per_page: 200,
      is_sold_out: 0,
      commodity_type: type,
      status: 1
    }

    let _list
    if (type == 8) {
      const {
        data: { list }
      } = await Api.getHallList(params)
      _list = list
    } else {
      const {
        data: { list }
      } = await Api.getResourcesList(params)
      _list = list
    }

    if (type == 0 || type == 8) {
      // 套餐 或 宴会厅
      this.allPackageList = _list || []
    } else {
      // 案例
      this.allCaseList = _list || []
    }
  }

  @action
  changeCaseModal = () => {
    this.caseModalStatus = !this.caseModalStatus
  }

  @action
  saveCase = async caseList => {
    if (caseList.length == 0) {
      message.warning('至少需要设置1个案例')
      return
    }
    if (caseList.length > 8) {
      message.warning('最多选择8个案例')
      return
    }
    const params = {
      entityIds: caseList.map(item => item.id).join(','),
      id: this.id,
      type: 7
    }
    const { success, data } = await Api.addResourcesList(params)
    if (success) {
      this.caseList = caseList.map(item => ({
        commodityType: item.commodity_type,
        coverPath: item.cover_path,
        id: item.id,
        title: item.title,
        publishedTime: item.published_time
      }))
      this.caseRecommendId = data
      this.changeCaseModal()
    }
  }

  @action
  changePackageModal = () => {
    this.packageModalStatus = !this.packageModalStatus
  }

  @action
  savePackage = async packageList => {
    if (packageList.length > 8) {
      message.warning(`最多选择8个${isHotelMerchant() ? '宴会厅' : '套餐'}`)
      return
    }
    const params = {
      entityIds: packageList.map(item => item.id).join(','),
      id: this.id,
      type: isHotelMerchant() ? 8 : 4
    }
    const { RetCode, data } = await Api.addResourcesList(params)
    if (RetCode === 0) {
      this.packageList = packageList.map(item => {
        if (isHotelMerchant()) {
          //对酒店特殊处理
          const {
            coverUrl,
            id,
            name,
            bestTableNum,
            maxTableNum,
            pillar,
            shape,
            height,
            area
          } = item
          return {
            commodityType: 8,
            coverPath: coverUrl,
            id,
            title: name,
            bestTableNum,
            maxTableNum,
            pillar,
            shape,
            height,
            area
          }
        } else {
          return {
            commodityType: item.commodity_type,
            coverPath: item.cover_path,
            id: item.id,
            title: item.title,
            publishedTime: item.published_time,
            actualPrice: item.actual_price,
            marketPrice: item.market_price,
            showPrice: item.show_price,
            intentType: item.intent_type,
            intentPrice: item.intent_price
          }
        }
      })
      this.packageRecommendId = data
      this.changePackageModal()
    }
  }

  @action
  onChangeSpreadModal = value => {
    this.spreadModal = !this.spreadModal
  }

  setVideoRef = ref => {
    this.videoRef = ref
  }

  initVideo = () => {
    // 直播已结束
    if (this.liveStatus == VIDEO_REVIEW) {
      const { fname, param } = this.detail.playback || {}
      if (fname) {
        try {
          new window.QPlayer({
            url: fname,
            container: this.videoRef,
            isLive: false
          })
        } catch (e) {
          this.detail.playback = {}
        }
      }

      if (param) {
        this.videoSeek = param
      }
    } else if (this.liveStatus == VIDEO_LIVING) {
      // 直播中
      const { coverUrl, playUrlWeb } = this.detail.stream || {}
      new window.QPlayer({
        url: playUrlWeb,
        container: this.videoRef,
        isLive: true,
        poster: coverUrl
      })
    } else {
      // cover_url
    }
  }

  @action
  changeLiveLine = async e => {
    const { success } = await Api.editLiveLine({
      id: this.id,
      liveLine: e.target.value
    })
    Modal.info({
      title: '提示',
      content:
        '切换线路成功！请先退出直播页面（暂时离开），再进入直播，即可使用切换后的线路',
      cancelText: '',
      okText: '知道了'
    })
    if (success) {
      this.detail.liveLine = e.target.value
    }
  }

  // 意向金更改
  @observable intentPrice = 0
  @action
  intentPriceChange = v => {
    this.intentPrice = v
  }

  // 意向金聚焦
  @observable lastIntentPrice
  @observable initial = true
  @action
  intentPriceFocus = intentPrice => () => {
    if (this.initial) {
      this.lastIntentPrice = intentPrice
    } else {
      this.lastIntentPrice = this.intentPrice
    }
  }

  // 意向金失焦
  @action
  intentPriceBlur = (refs, mealId, actualPrice, intentPrice) => () => {
    const maxIntentPrice = Math.min(100, actualPrice || 100)
    const isActualPrice = maxIntentPrice == actualPrice
    if (this.intentPrice > maxIntentPrice) {
      if (isActualPrice) {
        Modal.warning({
          title: '意向金不能大于套餐价格。',
          onOk: () => {
            refs.current.focus()
          }
        })
      } else {
        Modal.warning({
          title: '意向金最大可设置为100元。',
          onOk: () => {
            refs.current.focus()
          }
        })
      }
    } else if (
      (!this.intentPrice && !this.lastIntentPrice) ||
      this.intentPrice === this.lastIntentPrice
    ) {
      Modal.warning({
        title: '无需重复设置'
      })
    } else {
      // 记录此次失焦时的意向金
      this.lastIntentPrice = this.lastIntentPrice || intentPrice
      this.initial = false
      this.commitIntentPrice(mealId)
    }
  }

  @action
  commitIntentPrice = async mealId => {
    const params = {
      id: this.id,
      set_meal_id: mealId,
      intent_price: this.intentPrice
    }
    const { success } = await Api.setLiveChannelIntent(params)
    if (success) {
      message.success('意向金设置成功！')
      const hostId = this.detail.hostList[0].hostId
      await Api.chatAddMsg({
        channel_id: this.id,
        content: JSON.stringify({
          id: mealId,
          intent_price: this.intentPrice
        }),
        host_id: hostId,
        sign: sha1(`key=hunliji2016&host_id=${hostId}`),
        msg_kind: MSG_INTENT_CONFIG
      })
    }
  }
}
